import { render, staticRenderFns } from "./VentasAlPublico.vue?vue&type=template&id=4a2f935e&scoped=true&"
import script from "./VentasAlPublico.vue?vue&type=script&lang=js&"
export * from "./VentasAlPublico.vue?vue&type=script&lang=js&"
import style0 from "./VentasAlPublico.vue?vue&type=style&index=0&id=4a2f935e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2f935e",
  null
  
)

export default component.exports